<template>
  <div>
    <v-question :value="answer"
                @input="UpdateAnswer"
                :type="data.type"
                :options="data.options"
                :option-key="data.optionKey"
                :option-text="data.optionText"
                :text="data.text"
                :tip="data.tip"
                :placeholder="data.placeholder"
                :maxlength="data.maxlength"
                :column="data.column"
                :readonly="data.onlyread"
                :open-on-focus="openOnFocus"></v-question>
  </div>
</template>
<script>
  import question from '@/services/question.vue';
  export default {
    components: {
      "v-question": question
    },
    watch: {
      data: {
        handler(n, o) {
          this.Update(n);
        },
        deep: true
      },
      answer: {
        handler(n, o) {
          this.$emit("change", n);
        }, deep: false
      }
    },
    data() {
      return {
        data: undefined,
        answer: undefined
      }
    },
    props: {
      "value": Object,
      "isAdmin": Boolean,
      "openOnFocus": Boolean,
      "column": Boolean
    },
    methods: {
      Update(val) {
        this.$emit("input", val);
      },
      UpdateAnswer(val) {
        this.answer = val;
      }
    },
    created() {
      this.data = this.value;

      if (!this.data.column)
        this.data.column = this.column;

      if (!this.data.onlyread)
        this.data.onlyread = this.isAdmin;

      this.answer = this.value.model;
    },
    mounted() {

    }
  }
</script>
